// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_ip-1";
export var quotedThread = "_ip-0";